import React, { useState } from "react";
import "./updateTerminal.scss";

import { Close, SchoolOutlined } from "@mui/icons-material";

import { IconButton } from "@mui/material";
import { requestType, terminalType } from "../../../types/GlobalType";
import { accountService } from "../../../_services/accountServices";
import toast, { LoaderIcon } from "react-hot-toast";
import { API_CONFIG } from "../../../apiCaller/configuration.Caller";
import { catchErrorApiCall } from "../../../_services/apiUtils";
import ErrorBar from "../../../component/errorComp/ErrorBar.tsx";
import { useNavigate } from "react-router-dom";

interface Props {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  dispatchReload: () => void;
}
const NewTerminal = (props: Props) => {
  const navigate = useNavigate();
  const [terminalDesignation, setterminalDesignation] = useState("");
  const [terminalId, setTerminalId] = useState("");

  const [state, setState] = React.useState<requestType>({
    isLoading: false,
    errorMessage: false,
    successMessage: false,
  });

  const handleCreateTerminal = async () => {
    if (!terminalDesignation?.toString().length) {
      setState({
        ...state,
        errorMessage: "Veuiller complétez le nom du terminal",
      });
    }
    if (!terminalId?.toString().length) {
      setState({
        ...state,
        errorMessage: "Veuiller complétez l'Id du terminal",
      });
    }

    setState({ isLoading: true, errorMessage: null, successMessage: null });

    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }

    try {
      let data = { designation: terminalDesignation, uid: terminalId };
      const response = await API_CONFIG.TERMINAL.create(data, token);
      if (response.data.status === 201) {
        toast.success("Création Terminal effectuée avec succes", {
          duration: 3000,
        });
        setterminalDesignation("");
        setTerminalId("");
        props.setOpen(false);
        props.dispatchReload();
      } else {
        toast.error("Une erreur s'est produite, réesayez plus tard", {
          style: {
            backgroundColor: "#630f0f", // Custom background color
            color: "white", // Text color
            fontSize: "12px", // Font size
            zIndex: 9999,
          },
        });
      }
    } catch (error) {
      setState({ ...state, isLoading: false });
      catchErrorApiCall(error);
    }
  };

  return (
    <div className="UpdateTerminal">
      <div className="dialog_update">
        <div className="headerUpdate">
          <div className="titleUpdate">
            <div className="left_">
              <SchoolOutlined className="ico" />
              <span>Enregistrement - Terminal</span>
            </div>
            <IconButton>
              <Close className="ico" onClick={() => props.setOpen(false)} />
            </IconButton>
          </div>
        </div>

        <div className="body_update">
          {state.errorMessage && <ErrorBar title={state.errorMessage} />}

          <div className="item">
            <label>Désignation</label>
            <input
              placeholder="Identifiant"
              type="text"
              value={terminalDesignation}
              onChange={(e) => setterminalDesignation(e.target.value)}
            />
          </div>
          <div className="item">
            <label>Numéro ID</label>
            <input
              placeholder="Numéro id"
              type="text"
              value={terminalId}
              onChange={(e) => setTerminalId(e.target.value)}
            />
          </div>
        </div>
        <div className="btn">
          <button onClick={() => props.setOpen(false)}>Annuler</button>
          {state.isLoading ? (
            <button>
              <LoaderIcon />
            </button>
          ) : (
            <button onClick={handleCreateTerminal}>Enregistrer</button>
          )}
        </div>
      </div>
    </div>
  );
};

export default NewTerminal;
